import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Selectors
const getMarginalLayer = path(["domain", "ui", "marginalLayer"]);
export const selectMarginalLayer = createSelector(getMarginalLayer, identity);
export const selectMarginalLayerHeight = createSelector(
  getMarginalLayer,
  prop("height")
);
export const selectIsMarginalLayerEnabled = createSelector(
  getMarginalLayer,
  prop("isEnabled")
);

// Initial State
const initialState = () => ({
  height: 0,
  isEnabled: false
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
